import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import CommonResolutioncenterItemComponent from 'webapp/components/common/resolutioncenter-item';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export default class DesignerTopbarPopupResolutionCenterComponent extends PopupInnerContextComponent<PopupData.None> {
	@service('app-notifications') declare appNotificationsService: Service.AppNotifications;

	get model() {
		return this.appNotificationsService.sortedVisibleNotifications;
	}
	<template>
		<div class="context-ct">
			{{#if this.model}}
				<ul>
					{{#each this.model as |item|}}
						<CommonResolutioncenterItemComponent
							@model={{item}}
							@onClose={{this.close}}
						/>
					{{/each}}
				</ul>
			{{else}}
				<div class="empty">
					<em>There are no recent account alerts.</em>
				</div>
			{{/if}}
		</div>
	</template>
}
